<script lang="ts" setup>
import type { FiltersFormModel } from '../../../runtime/services/FilterService';

const props = defineProps<{
    item: Resource<FiltersFormModel>;
}>();
const emit = defineEmits<{
    (e: 'click', item: Resource<FiltersFormModel>): void;
}>();

const loaded = ref(false);
const button = ref(null);

onMounted(() =>
{
    loaded.value = true;
});

function onConfirm(item: Resource<FiltersFormModel>)
{
    emit('click', props.item);
}
</script>

<template>
    <IdeoButton ref="button" :title="$t('[[[Usuń filtr]]]')" size="sm" class="btn-link py-0 px-1 position-relative" @click.stop>
        <i class="far fa-times text-danger" />
        <Confirmation
            v-if="loaded"
            placement="bottomright"
            :message="$t('[[[Potwierdzenie usunięcia]]]')"
            :target="button.$el"
            :value="props.item"
            @confirm="onConfirm"
        />
    </IdeoButton>
</template>
